var fn = function( obj ){
var __t,__p='';
__p+=''+
( require( "@/webgl/glsl/includes/glsl-compat.frag" )() )+
'\n\nIN vec2 vTexCoord;\nIN vec2 vTexCoordGrad;\n\nuniform sampler2D tFontTex;\nuniform sampler2D tGradient;\nuniform vec3 uOffset;\n\n// https://drewcassidy.me/2020/06/26/sdf-antialiasing/\n\nvoid main(void) {\n\n  vec2 tcoord = vTexCoord;\n  tcoord.y = 1.0 - tcoord.y;\n\n  vec4 color = texture2D(tGradient, vTexCoordGrad);\n  float dist = (0.5 - texture2D(tFontTex, tcoord).r);\n  vec2 ddist = vec2(dFdx(dist), dFdy(dist));\n  float pixelDist = dist / length(ddist);\n  color.a = clamp(0.5 - pixelDist, 0.0, 1.0) * uOffset.z;\n\n  FragColor = color;\n\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;